// extracted by mini-css-extract-plugin
export default {"banner":"Banner_banner__ZCXhV","brand":"Banner_brand__ai+L-"};